/* Request a quote drawer.
 *
 * The panel is markup, in snippets/aps-quote-drawer.liquid, and it posts as an
 * ordinary Shopify contact form. This file is the parts of it that need a script:
 * the item list, the typeahead, the live validation, and carrying the reader's
 * work across the reload that posting costs.
 *
 * It deliberately does NOT submit with fetch. See the note at the top of the
 * snippet: /contact is behind hCaptcha here and answers a scripted POST with 403,
 * so a drawer that fetched would report success and email nobody.
 */
(function () {
  'use strict';

  var cfg = window.APSQuoteConfig || { searchUrl: '/search', fallbackUrl: '/pages/contact-us' };
  var KEY = 'aps_quote_state_v1';
  /* Shopify reports a successful contact post to EVERY contact form on the page,
     and a product page carries two: this drawer and the help panel's dialog. So
     a returning page cannot be asked which form posted, it has to be told. Each
     form writes its own token before submitting and only reacts to a post it
     finds its own token for. Without this, sending a quote also popped the help
     panel's "Thanks" dialog, and sending from the help panel would have popped
     this drawer's sent panel. */
  var OWN = 'aps_quote_post_v1';

  var root, overlay, drawer, inner, form, bodyEl, searchEl, resultsEl, itemsEl, emptyEl,
      nameEl, phoneEl, emailEl, companyEl, msgEl, submitEl, statusEl, statusTextEl,
      statusIcEl, progLabelEl, taxWrap, taxSeg, taxYes, taxNo,
      coverStep, routeEl, shapeEl, sizeEl, deckEl, brandEl, featuresEl,
      fields = {}, steps = {}, segs = [];

  var items = [], taxExempt = false, taxChosen = false, tried = false, kind = 'quote',
      openSource = 'manual', lastFocus = null, prevOverflow = '', searchTimer = null;


  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function ga(name, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, Object.assign({ transport_type: 'beacon' }, params || {}));
    }
  }

  /* ── open and close ───────────────────────────────────────────────────────
     The scroll lock saves what it found rather than clearing on the way out.
     The cart drawer and the DE grid template's add modal both lock the same
     property, and a blanket reset here would unlock the page underneath one of
     them that is still open. */
  function open(opts) {
    if (!drawer) return;
    opts = opts || {};
    overlay.hidden = false;
    drawer.hidden = false;
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
    });
    prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    lastFocus = document.activeElement;
    /* Reopening after a send starts a new quote, but the open that PUTS the sent
       panel up must not wipe the thing it came to show. Only that one call passes
       keepDone, so every reopen a reader can trigger resets. */
    if (!opts.keepDone && inner.classList.contains('is-done')) resetQuote();
    /* validate() after applyKind(), not before. Changing the kind changes which step one is, so the
       status line composed under the old kind is wrong the moment the swap happens: a cover request
       opened straight from a link read "Still needed: an item" on a panel with no item field. */
    if (opts.kind) { kind = isKind(opts.kind); applyKind(); validate(); }
    if (opts.product) addProductOnce(opts.product);
    openSource = opts.source || 'manual';
    setTimeout(function () {
      var target = searchEl && !items.length ? searchEl : (nameEl || searchEl);
      if (target) target.focus();
    }, 80);
    ga('quote_open', { source: openSource, kind: kind });
  }

  function close() {
    if (!drawer) return;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = prevOverflow;
    setTimeout(function () { overlay.hidden = true; drawer.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ── the item list ────────────────────────────────────────────────────── */
  /* Opening twice must not list the same product twice. Closing keeps the basket
     on purpose, so a reader who shuts the panel by accident does not lose their
     work, and that is exactly what makes the product a control adds on open a
     duplicate the second time round. Matched on the product url, falling back to
     the title, and never against a custom line, which is free text the reader
     may legitimately repeat. */
  function addProductOnce(p) {
    var key = String(p.url || p.title || '').trim();
    var already = items.some(function (it) {
      return !it.custom && String(it.url || it.title || '').trim() === key;
    });
    if (!already) addItem(p);
  }

  function addItem(obj) {
    items.push(Object.assign({ qty: 1, note: '', custom: false, sku: '', url: '', image: '' }, obj));
    if (searchEl) { searchEl.value = ''; }
    closeResults();
    render();
    ga('quote_add_item', { custom: !!obj.custom });
    if (searchEl) searchEl.focus();
  }

  function render() {
    if (!itemsEl) return;
    itemsEl.innerHTML = '';
    if (emptyEl) emptyEl.style.display = items.length ? 'none' : 'block';

    items.forEach(function (it, i) {
      var li = document.createElement('li');
      li.className = 'qitem' + (it.custom ? ' is-custom' : '');
      var thumb = it.image
        ? '<span class="qthumb"><img src="' + esc(it.image) + '" alt=""></span>'
        : '<span class="qthumb"><span class="qthumb-ph">' + (it.custom ? '&#9998;' : 'IMG') + '</span></span>';
      var meta = it.custom
        ? '<span class="qtag">Custom request</span>'
        : (it.sku ? '<div class="qmeta">' + esc(it.sku) + '</div>' : '');

      li.innerHTML = thumb +
        '<div class="qmain"><div class="qname">' + esc(it.title) + '</div>' + meta +
        '<textarea class="qnote" rows="1" placeholder="Add a note, size or spec">' + esc(it.note) + '</textarea></div>' +
        '<div class="qside">' +
          '<button type="button" class="qrm" aria-label="Remove item">' +
            '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13"/></svg>' +
          '</button>' +
          '<div class="qqty">' +
            '<button type="button" data-dec aria-label="Decrease">&minus;</button>' +
            '<input type="number" min="1" value="' + it.qty + '" aria-label="Quantity">' +
            '<button type="button" data-inc aria-label="Increase">+</button>' +
          '</div>' +
        '</div>';

      $('[data-dec]', li).onclick = function () { it.qty = Math.max(1, it.qty - 1); render(); };
      $('[data-inc]', li).onclick = function () { it.qty += 1; render(); };
      $('.qqty input', li).onchange = function (e) {
        it.qty = Math.max(1, parseInt(e.target.value, 10) || 1); render();
      };
      $('.qnote', li).oninput = function (e) { it.note = e.target.value; };
      $('.qrm', li).onclick = function () { items.splice(i, 1); render(); };
      itemsEl.appendChild(li);
    });
    validate();
  }

  /* ── typeahead ────────────────────────────────────────────────────────────
     Shopify's own suggest endpoint, so nothing has to be indexed or paid for and
     it stays correct at this catalogue's size. */
  function closeResults() {
    if (!resultsEl) return;
    resultsEl.classList.remove('is-open');
    resultsEl.hidden = true;
    resultsEl.innerHTML = '';
  }

  function doSearch(q) {
    var url = String(cfg.searchUrl || '/search').replace(/\/$/, '') +
      '/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var p = d && d.resources && d.resources.results && d.resources.results.products;
        renderResults(p || [], q);
      })
      .catch(function () { renderResults([], q); });
  }

  function renderResults(prods, q) {
    if (!resultsEl) return;
    var html = prods.map(function (p) {
      var img = p.image ? '<img src="' + esc(p.image) + '" alt="">' : 'IMG';
      var payload = esc(JSON.stringify({ title: p.title, url: p.url || '', image: p.image || '' }));
      return '<a class="qrow" data-pick="' + payload + '">' +
        '<span class="qrow-thumb">' + img + '</span>' +
        '<span><span class="qrow-name">' + esc(p.title) + '</span>' +
        (p.vendor ? '<span class="qrow-meta">' + esc(p.vendor) + '</span>' : '') + '</span>' +
        '<span class="qrow-add">+</span></a>';
    }).join('');

    /* Always last, never conditional. A parts caller whose tank has no model
       plate has to be able to finish this form. */
    html += '<a class="qrow is-custom" data-custom>' +
      '<span class="qrow-thumb">&#9998;</span>' +
      '<span><span class="qrow-name">Add "' + esc(q) + '" as a custom request</span>' +
      '<span class="qrow-meta">No exact product needed, describe it and we will source it</span></span>' +
      '<span class="qrow-add">+</span></a>';

    resultsEl.innerHTML = html;
    resultsEl.hidden = false;
    resultsEl.classList.add('is-open');
    all('[data-pick]', resultsEl).forEach(function (el) {
      el.onclick = function () { addItem(JSON.parse(el.getAttribute('data-pick'))); };
    });
    $('[data-custom]', resultsEl).onclick = function () {
      addItem({ title: searchEl.value.trim(), custom: true });
    };
  }

  /* ── validation ───────────────────────────────────────────────────────── */
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  function validate() {
    if (!submitEl) return false;
    var onCover = kind === 'cover';
    /* Step one is the items list normally and the pool specification in cover mode. Everything below
       treats them as the same slot, so the progress bar, the status line and the submit gate all keep
       counting to three. */
    var hasItems = onCover ? hasPool() : items.length > 0;
    var hasName = nameEl.value.trim().length > 0;
    var hasPhone = phoneEl.value.trim().length > 0;
    var hasEmail = validEmail(emailEl.value.trim());
    var step2 = hasName && hasPhone && hasEmail;
    var state = onCover ? [hasItems, step2] : [hasItems, step2, taxChosen];

    [1, 2, 3].forEach(function (n) {
      var el = (n === 1 && onCover) ? coverStep : steps[n];
      if (el) el.classList.toggle('is-complete', !!state[n - 1]);
    });
    if (tried && onCover) {
      if (fields.shape) fields.shape.classList.toggle('has-err', !(shapeEl && shapeEl.value));
      if (fields.size) fields.size.classList.toggle('has-err', !(sizeEl && sizeEl.value.trim()));
    }

    var firstOpen = state.indexOf(false);
    segs.forEach(function (seg, i) {
      seg.classList.remove('is-done', 'is-active');
      if (i >= state.length) return;
      if (state[i]) seg.classList.add('is-done');
      else if (i === firstOpen) seg.classList.add('is-active');
    });
    if (progLabelEl) {
      progLabelEl.textContent = state.filter(Boolean).length + ' of ' + state.length + ' steps complete';
    }

    var ok = hasItems && step2 && (onCover || taxChosen);
    submitEl.disabled = !ok;

    if (statusEl) {
      if (ok) {
        statusEl.classList.add('is-ready');
        if (statusIcEl) statusIcEl.innerHTML = '&#10003;';
        if (statusTextEl) statusTextEl.textContent = 'All set, send your request';
      } else {
        statusEl.classList.remove('is-ready');
        if (statusIcEl) statusIcEl.innerHTML = '&#9888;';
        var missing = [];
        if (!hasItems) missing.push(onCover ? 'your pool shape and size' : 'an item');
        if (!hasName) missing.push('name');
        if (!hasPhone) missing.push('phone');
        if (!hasEmail) missing.push('email');
        if (!taxChosen && !onCover) missing.push('tax status');
        if (statusTextEl) statusTextEl.textContent = 'Still needed: ' + missing.join(', ');
      }
    }

    /* Only after an attempt. Marking a field red because the reader has not
       reached it yet is the form telling them off for its own ordering. */
    if (tried) {
      if (fields.name) fields.name.classList.toggle('has-err', !hasName);
      if (fields.phone) fields.phone.classList.toggle('has-err', !hasPhone);
      if (fields.email) fields.email.classList.toggle('has-err', !hasEmail);
      if (emptyEl) emptyEl.classList.toggle('is-required', !hasItems);
      if (taxWrap) taxWrap.classList.toggle('has-err', !taxChosen);
    }
    syncFields();
    return ok;
  }

  /* ── what the notification email says ────────────────────────────────────
     Written to be read by whoever picks the quote up, top to bottom, without
     scrolling past anything. Shopify renders the labelled fields first and this
     body underneath, so this is the part that has to carry the actual request.

     It used to be accompanied by the same items again as escaped JSON in a
     contact[Items] field, which pushed everything readable below the fold. */
  /* ── the two requests this panel serves ──────────────────────────────────
     Same form, same items, same contact details. What differs is what the store
     is being asked for, which decides the routing field a mail rule keys on and
     the line the notification email leads with. */
  var KINDS = {
    quote:  { form: 'Quote request',          heading: 'QUOTE REQUEST' },
    volume: { form: 'Volume pricing request', heading: 'VOLUME PRICING REQUEST' },
    /* A custom safety cover is made to measure, so it is not a catalogue item and the product search
       cannot serve it. In this kind the pool specification step replaces the items step. */
    cover:  { form: 'Custom cover request',   heading: 'CUSTOM SAFETY COVER REQUEST' }
  };
  function isKind(k) { return Object.prototype.hasOwnProperty.call(KINDS, k) ? k : 'quote'; }
  function kindOf() { return KINDS[kind] || KINDS.quote; }

  /* Swap any element carrying an alternate for the current kind. The default wording is the element's
     own text, so quote needs nothing stored: it is what shipped. Generalised from a volume only swap
     when the cover kind arrived, so an element may carry data-volume, data-cover or both. */
  function applyKind() {
    all('[data-volume],[data-cover]', root).forEach(function (el) {
      if (!el.hasAttribute('data-quote-copy')) el.setAttribute('data-quote-copy', el.textContent);
      var alt = el.getAttribute('data-' + kind);
      el.textContent = alt == null ? el.getAttribute('data-quote-copy') : alt;
    });
    /* The pool step and the product step are alternatives, never both. */
    var onCover = kind === 'cover';
    if (coverStep) coverStep.hidden = !onCover;
    if (steps[1]) steps[1].hidden = onCover;
    /* No tax question on a custom cover. Dylan, 2026-09-23: this is a homeowner buying one cover for
       their own pool, not a business buying stock, so asking about exemption is a step that earns
       nothing and costs a completion. The quote and volume kinds keep it. */
    if (steps[3]) steps[3].hidden = onCover;
    if (segs[2]) segs[2].hidden = onCover;
    if (msgEl) {
      var ph = msgEl.getAttribute('data-cover-placeholder');
      if (!msgEl.hasAttribute('data-quote-placeholder')) {
        msgEl.setAttribute('data-quote-placeholder', msgEl.getAttribute('placeholder') || '');
      }
      msgEl.setAttribute('placeholder', onCover && ph ? ph : msgEl.getAttribute('data-quote-placeholder'));
    }
  }

  /* What the reader ticked and typed about their pool, in the order a cover specialist reads it. */
  function featureList() {
    if (!featuresEl) return [];
    return all('input:checked', featuresEl).map(function (b) { return b.value; });
  }
  function poolSpec() {
    if (kind !== 'cover') return '';
    var out = [];
    if (shapeEl && shapeEl.value) out.push('Shape: ' + shapeEl.value);
    if (sizeEl && sizeEl.value.trim()) out.push('Size: ' + sizeEl.value.trim());
    if (deckEl && deckEl.value) out.push('Deck: ' + deckEl.value);
    var f = featureList();
    out.push('Works around: ' + (f.length ? f.join(', ') : 'nothing noted'));
    if (brandEl && brandEl.value.trim()) out.push('Current cover: ' + brandEl.value.trim());
    if (routeEl && routeEl.value) out.push('Route: ' + routeEl.value);
    return out.join('\n');
  }
  function hasPool() {
    return !!(shapeEl && shapeEl.value && sizeEl && sizeEl.value.trim());
  }

  function sourceLabel(s) {
    return {
      buy_panel: 'the buy panel on a product page',
      band: 'the quote band on a product page',
      url: 'a direct quote link',
      link: 'a link',
      'return': 'a link',
      custom_cover: 'the custom safety cover page',
      manual: 'the store'
    }[s] || s;
  }

  /* The page the request came from, without the parameters Shopify adds on the
     way back from a post. Those are ours and mean nothing to a sales agent. */
  function pageUrl() {
    try {
      var u = new URL(window.location.href);
      ['contact_posted', 'form_type', 'form_key'].forEach(function (k) { u.searchParams.delete(k); });
      return u.origin + u.pathname + u.search;
    } catch (e) { return window.location.href; }
  }

  function composeBody() {
    var out = [];
    if (kind === 'cover') {
      out.push(kindOf().heading);
      out.push('');
      out.push('THE POOL');
      out.push(poolSpec());
      out.push('');
      if (msgEl.value.trim()) {
        out.push('WHAT THEY ADDED');
        out.push(msgEl.value.trim());
        out.push('');
      }
      out.push('Asked from ' + sourceLabel(openSource) + '.');
      return out.join('\n');
    }
    out.push(kindOf().heading + ', ' + items.length + (items.length === 1 ? ' item' : ' items'));
    out.push('');

    items.forEach(function (it, i) {
      out.push((i + 1) + ')  ' + it.qty + ' x  ' + it.title);
      if (it.custom) out.push('    No catalogue match, this one is described rather than picked.');
      else if (it.sku) out.push('    SKU   ' + it.sku);
      if (it.url) out.push('    Link  ' + it.url);
      if (it.note) out.push('    Note  ' + it.note);
      out.push('');
    });

    if (msgEl.value.trim()) {
      out.push('WHAT THEY ADDED');
      out.push(msgEl.value.trim());
      out.push('');
    }

    out.push('Asked from ' + sourceLabel(openSource) + '.');
    return out.join('\n');
  }

  function setHidden(sel, value) {
    var el = $(sel, root);
    if (el) el.value = value;
  }

  /* ── the hidden fields are kept current, not filled at the last moment ──────
     Shopify's own storefront script (standard-actions.js) intercepts the submit
     of a contact form, cancels it, runs the captcha, and submits again itself.
     Measured here: a submit event reaches window with defaultPrevented true and
     no navigation follows until that machinery decides to send it.

     That makes "populate the hidden fields inside the submit handler" a bet on
     running before an interceptor we do not control, and on that interceptor
     resubmitting the live DOM rather than a snapshot it took earlier or a copy
     it stashed in sessionStorage across the challenge. Keeping the fields in
     step with the form at all times removes the bet: whatever moment anything
     else reads this form, the whole request is already in it. */
  function syncFields() {
    if (!root) return;
    setHidden('[data-apsq-form-field]', kindOf().form);
    setHidden('[data-apsq-tax-field]', kind === 'cover' ? 'Not asked' : (taxExempt ? 'Yes' : 'No'));
    setHidden('[data-apsq-phone-field]', phoneEl ? phoneEl.value.trim() : '');
    setHidden('[data-apsq-company-field]', companyEl ? companyEl.value.trim() : '');
    setHidden('[data-apsq-page-field]', pageUrl());
    setHidden('[data-apsq-pool-field]', poolSpec());
    setHidden('[data-apsq-body-field]', composeBody());
  }

  /* ── carrying the reader's work across the reload ─────────────────────────
     Posting reloads, and an hCaptcha challenge reloads twice. Without this the
     reader comes back to an empty basket and blames the form. */
  function save() {
    try {
      window.sessionStorage.setItem(KEY, JSON.stringify({
        items: items, taxExempt: taxExempt, taxChosen: taxChosen,
        name: nameEl.value, phone: phoneEl.value, email: emailEl.value,
        company: companyEl.value, msg: msgEl.value, source: openSource, kind: kind,
        pool: {
          route: routeEl ? routeEl.value : '', shape: shapeEl ? shapeEl.value : '',
          size: sizeEl ? sizeEl.value : '', deck: deckEl ? deckEl.value : '',
          brand: brandEl ? brandEl.value : '', features: featureList()
        }
      }));
    } catch (e) { /* private mode: the round trip loses the basket, nothing worse */ }
  }

  function restore() {
    var raw;
    try { raw = window.sessionStorage.getItem(KEY); } catch (e) { return false; }
    if (!raw) return false;
    var s;
    try { s = JSON.parse(raw); } catch (e) { return false; }
    items = Array.isArray(s.items) ? s.items : [];
    taxExempt = !!s.taxExempt;
    taxChosen = !!s.taxChosen;
    if (nameEl) nameEl.value = s.name || '';
    if (phoneEl) phoneEl.value = s.phone || '';
    if (emailEl) emailEl.value = s.email || '';
    if (companyEl) companyEl.value = s.company || '';
    if (msgEl) msgEl.value = s.msg || '';
    openSource = s.source || 'manual';
    kind = isKind(s.kind);
    var pool = s.pool || {};
    if (routeEl) routeEl.value = pool.route || routeEl.value;
    if (shapeEl) shapeEl.value = pool.shape || '';
    if (sizeEl) sizeEl.value = pool.size || '';
    if (deckEl) deckEl.value = pool.deck || '';
    if (brandEl) brandEl.value = pool.brand || '';
    if (featuresEl && Array.isArray(pool.features)) {
      all('input', featuresEl).forEach(function (b) { b.checked = pool.features.indexOf(b.value) >= 0; });
    }
    applyKind();
    if (taxChosen) paintTax();
    render();
    return true;
  }

  function clear() {
    try { window.sessionStorage.removeItem(KEY); } catch (e) {}
  }

  function markSubmitting() {
    try { window.sessionStorage.setItem(OWN, '1'); } catch (e) {}
  }
  function ownsPost() {
    try { return window.sessionStorage.getItem(OWN) === '1'; } catch (e) { return false; }
  }
  function releasePost() {
    try { window.sessionStorage.removeItem(OWN); } catch (e) {}
  }

  /* Shopify renders the sent state from the URL, so without this a reload of the
     page you land on after posting renders it again, and the panel reopens
     claiming a request was sent that was not. Taking the parameters off means a
     refresh is an ordinary page. */
  function scrubUrl() {
    if (!window.history || !window.history.replaceState) return;
    try {
      var u = new URL(window.location.href);
      ['contact_posted', 'form_type', 'form_key'].forEach(function (k) { u.searchParams.delete(k); });
      window.history.replaceState({}, '', u.pathname + u.search);
    } catch (e) { /* nothing here is worth breaking the page for */ }
  }

  /* Back to a blank request, without a page load. Reopening after sending one
     should be a new quote, not the last one's receipt. */
  function resetQuote() {
    inner.classList.remove('is-done');
    items = []; taxExempt = false; taxChosen = false; tried = false;
    kind = 'quote'; applyKind();
    [nameEl, phoneEl, emailEl, companyEl, msgEl].forEach(function (el) { if (el) el.value = ''; });
    if (taxYes) taxYes.classList.remove('is-on');
    if (taxNo) taxNo.classList.add('is-on');
    if (taxSeg) taxSeg.classList.add('is-unset');
    [fields.name, fields.phone, fields.email].forEach(function (f) { if (f) f.classList.remove('has-err'); });
    if (emptyEl) emptyEl.classList.remove('is-required');
    if (taxWrap) taxWrap.classList.remove('has-err');
    var e = $('[data-apsq-state="error"]', root);
    if (e) e.remove();
    clear();
    render();
  }

  function paintTax() {
    if (taxYes) taxYes.classList.toggle('is-on', taxExempt);
    if (taxNo) taxNo.classList.toggle('is-on', !taxExempt);
    if (taxSeg) taxSeg.classList.remove('is-unset');
  }

  function onSubmit(e) {
    tried = true;
    if (!validate()) {
      e.preventDefault();
      if (!items.length) searchEl.focus();
      else if (!nameEl.value.trim()) nameEl.focus();
      else if (!phoneEl.value.trim()) phoneEl.focus();
      else if (!validEmail(emailEl.value.trim())) emailEl.focus();
      return;
    }
    syncFields();
    save();
    markSubmitting();
    /* Not prevented, and there is no longer any branch above that prevents it
       either. With the honeypot gone, the ONLY route to the sent panel is
       Shopify reporting the post succeeded, on a post this drawer owns. Nothing
       client side can claim a request was sent. Keep it that way. */
  }

  /* ── the product the reader is looking at ─────────────────────────────────
     Read from the buy panel's own hooks rather than scraped out of an h1. */
  function currentProduct() {
    var t = $('[data-aps-title]');
    var sku = $('[data-aps-sku]');
    var img = $('meta[property="og:image"]');
    if (!t) return null;
    return {
      title: (t.textContent || '').trim(),
      sku: sku ? (sku.textContent || '').trim() : '',
      url: window.location.href.split('#')[0].split('?')[0],
      image: img ? img.getAttribute('content') : ''
    };
  }

  function trap(e) {
    if (!drawer || drawer.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = all('a[href],button:not([disabled]),input,textarea,[tabindex]:not([tabindex="-1"])', drawer)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* Runs the moment the panel's markup exists, rather than at DOMContentLoaded.
     This is a race, and it decides whether a quote arrives with a body. Coming
     back from a captcha challenge, Shopify's own script repopulates the form and
     resubmits it by itself, on its own schedule. Everything it sends has to
     already be in the form by then, and waiting for DOMContentLoaded is a bet
     that we win that race.

     The script tag sits at the end of the panel's own snippet, so the element is
     always parsed by the time this runs, and there is nothing later in the
     document this needs. */
  function ready(fn) {
    if (document.querySelector('[data-aps-quote]')) fn();
    else if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    root = $('[data-aps-quote]');
    if (!root) return;
    overlay = $('[data-apsq-overlay]', root);
    drawer = $('[data-apsq-drawer]', root);
    inner = $('[data-apsq-in]', root);
    form = $('form', root);

    overlay.addEventListener('click', close);
    all('[data-apsq-close]', root).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', trap);

    /* Any control anywhere opens it, and each keeps a real href so a page whose
       script failed still lands the reader somewhere that can take the request. */
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-open-quote],a[href$="#request-quote"],a[href*="quote=open"]');
      if (!t) return;
      e.preventDefault();
      var product = null;
      if (t.hasAttribute('data-quote-product')) {
        try { product = JSON.parse(t.getAttribute('data-quote-product')); } catch (err) { product = currentProduct(); }
      }
      open({ source: t.getAttribute('data-quote-source') || 'link',
             kind: t.getAttribute('data-quote-kind') || 'quote',
             product: product });
    });

    bodyEl = $('[data-apsq-body]', root);
    searchEl = $('[data-apsq-search]', root);
    resultsEl = $('[data-apsq-results]', root);
    itemsEl = $('[data-apsq-items]', root);
    emptyEl = $('[data-apsq-empty]', root);
    nameEl = $('[data-apsq-name]', root);
    phoneEl = $('[data-apsq-phone]', root);
    emailEl = $('[data-apsq-email]', root);
    companyEl = $('[data-apsq-company]', root);
    msgEl = $('[data-apsq-msg]', root);
    submitEl = $('[data-apsq-submit]', root);
    statusEl = $('[data-apsq-status]', root);
    statusTextEl = $('[data-apsq-status-text]', root);
    statusIcEl = $('[data-apsq-status-ic]', root);
    progLabelEl = $('[data-apsq-proglabel]', root);
    taxWrap = $('[data-apsq-tax-wrap]', root);
    taxSeg = $('[data-apsq-tax]', root);
    taxYes = $('[data-apsq-tax-yes]', root);
    taxNo = $('[data-apsq-tax-no]', root);
    coverStep = $('[data-apsq-step="1c"]', root);
    routeEl = $('[data-apsq-route]', root);
    shapeEl = $('[data-apsq-shape]', root);
    sizeEl = $('[data-apsq-size]', root);
    deckEl = $('[data-apsq-deck]', root);
    brandEl = $('[data-apsq-brand]', root);
    featuresEl = $('[data-apsq-features]', root);
    fields.shape = $('[data-apsq-f="shape"]', root);
    fields.size = $('[data-apsq-f="size"]', root);
    [routeEl, shapeEl, sizeEl, deckEl, brandEl, featuresEl].forEach(function (el) {
      if (!el) return;
      el.addEventListener('input', validate);
      el.addEventListener('change', validate);
    });
    steps[1] = $('[data-apsq-step="1"]', root);
    steps[2] = $('[data-apsq-step="2"]', root);
    steps[3] = $('[data-apsq-step="3"]', root);
    segs = all('[data-apsq-seg]', root);
    fields.name = $('[data-apsq-f="name"]', root);
    fields.phone = $('[data-apsq-f="phone"]', root);
    fields.email = $('[data-apsq-f="email"]', root);

    /* The toggle starts genuinely unset. Howdy's initialises to chosen, so its
       third step reads complete before the reader has answered it. */
    if (taxSeg) taxSeg.classList.add('is-unset');

    searchEl.addEventListener('input', function () {
      var q = searchEl.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) { closeResults(); return; }
      searchTimer = setTimeout(function () { doSearch(q); }, 200);
    });
    searchEl.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !searchEl.value.trim()) return;
      e.preventDefault();
      var first = $('[data-pick]', resultsEl);
      if (first) first.click();
      else addItem({ title: searchEl.value.trim(), custom: true });
    });
    document.addEventListener('click', function (e) {
      if (!resultsEl || drawer.hidden) return;
      if (!resultsEl.contains(e.target) && e.target !== searchEl) closeResults();
    });

    [nameEl, phoneEl, emailEl].forEach(function (el) { el.addEventListener('input', validate); });
    /* Not validated, but it still has to reach the email, and syncFields runs
       from validate. */
    [companyEl, msgEl].forEach(function (el) { if (el) el.addEventListener('input', syncFields); });

    function pickTax(v) { taxExempt = v; taxChosen = true; paintTax(); validate(); }
    taxYes.addEventListener('click', function () { pickTax(true); });
    taxNo.addEventListener('click', function () { pickTax(false); });

    form.addEventListener('submit', onSubmit);

    /* Coming back from a post.
       Three shapes arrive here, and every one of them is reported to both contact
       forms on the page, so each is gated on this drawer's own token:
         posted    Shopify accepted a contact form
         err       Shopify rejected one
         challenge the hCaptcha round trip, which renders neither result
       A post this drawer did not start is ignored completely, which is what keeps
       sending a quote from popping the help panel's dialog and the other way
       round. */
    var q = new URLSearchParams(window.location.search);
    var posted = $('[data-apsq-posted]', root);
    var err = $('[data-apsq-state="error"]', root);
    var doneEl = $('[data-apsq-done]', root);
    var challenge = !posted && !err && q.get('form_type') === 'contact';
    var mine = ownsPost();

    render();

    if (posted && mine) {
      /* The only path that claims success. Shopify said so, and the token says
         it was this form that asked. */
      releasePost();
      clear();
      scrubUrl();
      inner.classList.add('is-done');
      ga('quote_submit', { kind: kind });
      open({ source: 'return', keepDone: true });
      if (doneEl) doneEl.focus();
    } else if (err && mine) {
      releasePost();
      scrubUrl();
      restore();
      tried = true;
      validate();
      open({ source: 'return' });
      err.focus();
    } else if (challenge && mine) {
      /* Restored, but NOT opened, and that distinction is the whole point.

         Shopify renders its hCaptcha challenge into the theme's own layout, so
         this panel is on that page too, and opening it put a scroll locking
         drawer and a scrim over the "I am human" checkbox the reader has to
         reach. The request cannot complete while the panel is in front of the
         thing that completes it.

         Nothing is lost by staying shut. Shopify carries its own copy of the
         form across the challenge and resubmits it, which is what actually
         sends the request, and the token is kept so the contact_posted that
         comes back is still recognised as ours. restore() runs because it
         repopulates the panel in place: a reader who abandons the challenge and
         reaches for the quote button again finds their basket still in it. */
      restore();
    } else if (!posted && !err && !challenge) {
      if (window.location.hash.indexOf('request-quote') > -1 || q.get('quote') === 'open') {
        open({ source: 'url', kind: isKind(q.get('kind')) });
      }
    }

    window.APSQuote = { open: open, close: close };
  });
})();
